export const amplitudeEventsName = {
    POSITION_PUBLISHED_ONBOARDING: 'position-published-onboarding',
    CUSTOMIZED_APP_QUESTIONS: 'customized-app-questions',
    VIEWD_ONBOARDING_STEPS: 'viewed-onboarding-step',
    SUBSCRIPTION_PLAN_SELECTED: 'subscription-plan-selected',
    ADDED_POSITION_ONBOARDING: 'added-position-onboarding',
    UPGRADE_STARTER_BUTTON: 'upgrade_button_starter',
    UPGRADE_SMARTER_BUTTON: 'upgrade_button_smarter',
    UPGRADE_PRO_BUTTON: 'upgrade_button_pro',
    SUBSCRIPTION_UPGRADE_SMARTER: 'subscription-upgrade-smarter',
    SUBSCRIPTION_UPGRADE_PRO: 'subscription-upgrade-pro',
    MANAGE_SUBSCRIPTION_BUTTON: 'manage-subscription-button',
    BILLING_CYCLE_MONTHLY_BUTTON: 'billing_cycle_monthly_button',
    BILLING_CYCLE_BIANNUAL_BUTTON: 'billing_cycle_biannual_button',
    BILLING_CYCLE_ANNUAL_BUTTON: 'billing_cycle_annual_button',
    BILLING_CYCLE_CHANGED: 'billing_cycle_changed',
    EXPIRED_CLICK_UPGRADE_BUTTON: 'expired-clicked-upgrade-button',
    VIEWD_SCREEN: 'viewed-screen',
    // CheckList Events
    VIEWD_SCREEN_CHECKLIST: 'viewed-screen-checklist',
    CHECKLIST_NAV_BUTTON: 'Checklist-Nav-Button',
    CHECKLIST_CLOSE_FOR_NOW_BUTTON: 'checklist-close-for-now-button',
    CHECKLIST_DONT_SHOW_AGAIN_BUTTON: 'checklist-dont-show-again-button',
    CHECKLIST_HIRING_PAGE_BUTTON: 'checklist-hiring-page-button',
    CHECKLIST_ADD_LOGO_LINK_BUTTON: 'checklist-add-logo-link-click',
    CHECKLIST_JOB_DESCRIPTION_LINK_BUTTON: 'checklist-job-description-link-click',
    CHECKLIST_QUALIFYING_QUESTIONS_lINK_BUTTON: 'checklist-qualifying-questions-link-click',
    CHECKLIST_HIRING_LINK_COPY_BUTTON: 'checklist-hiring-link-copy-button',
    CHECKLIST_SETUP_QUALIFYING_QUESTIONS_LINK_BUTTON: 'checklist-setup-qualifying-questions-link-click',
    CHECKLIST_SETUP_INTERVIEWS_LINK_BUTTON: 'checklist-setup-interviews-link-click',
    CHECKLIST_AUTOSAVE_LINK_BUTTON: 'checklist-autosave-link-click',
    CHECKLIST_SETUP_ONBOARDING_LINK_BUTTON: 'checklist-setup-onboarding-link-click',
    MARK_COMPLETE_STEP_BUTTON: 'mark-complete-step',
    // Employer Dashboard Events
    APPLICANTS_CLICK_BOOST_MY_JOBS: 'Applicants-click-boost-my-jobs',
    APPLICANTS_CLICK_ADD_APPLICANT: 'Applicants-click-Add-Applicant',
    APPLICANTS_CLICK_APPLICANT: 'Applicants-click-applicant',
    APPLICANTS_CLICK_POSITION: 'Applicants-click-positions',
    APPLICANTS_CLICK_SHARE_HIRING: 'Applicants-click-share-hiring',
    APPLICANTS_CLICK_POST_JOB_SOCIAL: 'Applicants-click-post-job-social',
    APPLICANTS_CLICK_REQUEST_SOCIAL_BOOST: 'Applicants-click-request-social-boost',
    APPLICANTS_CLICK_REQUEST_LOCATION_BOOST: 'Applicants-click-request-location-boost',
    APPLICANTS_CLICK_ADD_APPLICANT_IN_MODAL: 'Applicants-click-add-applicant',
    APPLICANTS_CLICK_ADD_HIRE_IN_MODAL: 'Applicants-click-add-hire',
    APPLICANTS_CLICK_VERIFY: 'Applicants-click-verify',
    APPLICANTS_CLICK_DOWNLOAD_APPLICATION: 'Applicants-click-download-application',
    APPLICANTS_CLICK_MESSAGE_APPLICANT: 'Applicants-click-message-applicant',
    APPLICANTS_CLICK_SAVE_APPLICANT: 'Applicants-click-move-to-save',
    APPLICANTS_CLICK_INTERVIEW_APPLICANT: 'Applicants-click-interview',
    APPLICANTS_CLICK_SEND_OFFER: 'Applicants-click-send-offer',
    APPLICANTS_CLICK_DECLINED: 'Applicants-click-declined',
    APPLICANTS_CLICK_ARCHIVE: 'Applicants-click-archive',
    APPLICANTS_CLICK_DIGITAL_ONBOARDING: 'Applicants-click-digital-onboarding',
    APPLICANTS_CLICK_TURN_ON_ONBOARDING: 'Applicants-click-turn-on-onboarding',
    APPLICANTS_CLICK_ONBOARDING_SETTINGS: 'Applicants-click-onboarding-settings',
    APPLICANTS_CLICK_SEND_ONBOARDING_DECUMENTS: 'Applicants-click-send-onboarding-documents',
    //onboarding screen events
    ONBOARDING_CLICK_APPLICANT:'Onboarding-click-applicant',
    ONBOARDING_CLICK_ONBOARDING_SETUP_NAV:'Onboarding-click-onboarding-setup-nav',
    ONBOARDING_CLICK_ADD_ONBOARDING_PACKAAGE:'Onboarding-click-add-onboarding-package',
    ONBOARDING_CLICK_ADD_PAYROLL_PARTNER: "Onboarding-click-add-payroll-partner",
    ONBOARDING_CLICK_SAVE_PAYROLL_PARTNER: "Onboarding-click-save-payroll-partner",
    ONBOARDING_CLICK_FIELD_NAME: "Onboarding-click-field-name",
    ONBOARDING_CLICK_SELECT_DOCUMENT: "Onboarding-click-select-document",
    ONBOARDING_CLICK_ADD_DOCUMENT: "Onboarding-click-add-document",
    ONBOARDING_CLICK_SELECT_POSITION: "Onboarding-click-select-position",
    ONBOARDING_CLICK_ADD_POSITION: "Onboarding-click-add-position",
    ONBOARDING_CLICK_UPLOAD_DOCUMENT: "Onboarding-click-upload-document",
    ONBOARDING_CLICK_SAVE_ONBOARDING_PACKAGE: "Onboarding-click-save-onboarding-package",
    ONBOARDING_CLICK_UPLOAD_DOCUMENT_FIELD: "Onboarding-click-upload-document-field",
    ONBOARDING_DOCUMENT_UPLOADED: "Onboarding-document-uploaded",
    //Job Position Events
    JOBMANAGEMENT_CLICK_ADD_POSITION: 'JobManagement-click-add-position',
    JOBMANAGEMENT_CLICK_VIEW_JOBPAGE: 'JobManagement-click-view-jobpage',
    JOBMANAGEMENT_CLICK_EDIT_JOB: 'JobManagement-click-edit-job',
    JOBMANAGEMENT_CLICK_VIEW_POSITION: 'JobManagement-click-view-position',
    JOBMANAGEMENT_CLICK_ARCHIVE_POSITION: 'JobManagement-click-archive-position',
    JOBMANAGEMENT_CLICK_CLOSE_POSITION: 'JobManagement-click-close-position',
    JOBMANAGEMENT_CLICK_ACCEPTING_POSITION: 'JobManagement-click-accepting-position',
    JOBMANAGEMENT_CLICK_HIRING_POSITION: 'JobManagement-click-hiring-position',
    JOBMANAGEMENT_CLICK_TURN_ON_AUTOMATION_NAV: 'JobManagement-click-turn-on-automation-nav',
    JOBMANAGEMENT_CLICK_TURN_ON_AUTOMATION_PAGE: 'JobManagement-click-turn-on-automation-page',
    JOBMANAGEMENT_CLICK_GET_SMARTER: 'JobManagement-click-get-smarter',
    JOBMANAGEMENT_CLICK_FIELD_DECLINED: 'JobManagement-click-field-declined',
    JOBMANAGEMENT_CLICK_FIELD_UNATTENDED: 'JobManagement-click-field-unattended',
    JOBMANAGEMENT_CLICK_FIELD_NO_RESPONSE: 'JobManagement-click-field-no-response',
    JOBMANAGEMENT_CLICK_FIELD_REMINDER_MESSAGE: 'JobManagement-click-field-reminder-message',
    JOBMANAGEMENT_CLICK_FIELD_DROPDOWN_CUSTOM: 'JobManagement-click-field-dropdown-custom',
    JOBMANAGEMENT_CLICK_FIELD_CUSTOM: 'JobManagement-click-field-custom',
    JOBMANAGEMENT_CLICK_FIELD_REMINDER_INTERVIEW: 'JobManagement-click-field-reminder-interview',
    JOBMANAGEMENT_CLICK_TOGGLE_SAVE: 'JobManagement-click-toggle-save',
    JOBMANAGEMENT_CLICK_TOGGLE_INVITE: 'JobManagement-click-toggle-invite',
    JOBMANAGEMENT_CLICK_TOGGLE_TEAM: 'JobManagement-click-toggle-team',
    JOBMANAGEMENT_CLICK_FIELD_DROPDOWN_JOBBOARD: 'JobManagement-click-field-dropdown-jobboard',
    JOBMANAGEMENT_CLICK_SAVE_JOB: 'JobManagement-click-save-job',
    // Upgrade Promots
    SUCCESSFUL_HIRE_STARTER_POPUP_UPGRADE_BUTTON: 'successful-hire-starter-popup-upgrade-button',
    SUCCESSFUL_HIRE_SMARTER_POPUP_UPGRADE_BUTTON: 'successful-hire-smarter-popup-upgrade-button',
    SUCCESSFUL_HIRE_SMARTER_UPGRADE_COMPLETED: 'successful-hire-upgrade-smarter-completed',
    SUCCESSFUL_HIRE_STARTER_TAKE_ME_THERE_BUTTON: 'successful-hire-starter-TakeMeThere-button',
    SUCCESSFUL_HIRE_STARTER_UPGRADE_COMPLETED: 'successful-hire-starter-upgrade-completed',
    SUCCESSFUL_HIRE_SMARTER_ONBOARDING_BUTTON: 'Successful-hire-smarter-popup-onboarding-button',
    SUCCESSFUL_HIRE_PRO_UPGRADE_COMPLETED: 'successful-hire-upgrade-pro-completed',
    SUCCESSFUL_HIRE_SMARTER_TAKE_ME_THERE_BUTTON: 'successful-hire-smarter-TakeMeThere-button',
    SUCCESSFUL_HIRE_SMARTER_APPLICANTS_PAGE_ONBOARDING_BUTTON: 'successful-hire-smarter-Applicants-page-onboarding-button',
    SUCCESSFUL_HIRE_STARTER_APPLICANTS_PAGE_ONBOARDING_BUTTON: 'successful-hire-starter-Applicants-page-onboarding-button',
    SUCCESSFUL_HIRE_SMARTER_JOB_MANAGEMENT_PAGE_ONBOARDING_BUTTON: 'successful-hire-smarter-JobManagement-page-onboarding-button',
    // More Location
    REQUEST_MORE_INFORMATION: 'Request-more-information-clicked',
    REQUEST_MORE_INFORMATION_CLICKED_APPLICANTS: 'request-more-information-clicked-applicants',
    REQUEST_MORE_INFORMATION_CLICKED_MANAGE_USERS: 'request-more-information-clicked-manage-users',
    MORE_LOCATIONS_YES_CLICKED: 'More-locations-yes-clicked',
    MORE_LOCATIONS_NO_CLICKED: 'More-locations-no-clicked',
    FORM_SUBMITTED_MULTIPLE_LOCATIONS: 'Form-Submitted-Multiple-Locations',
};
